import * as React from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { getTemplate } from "@/templates/registry";

interface Props {
  data: { templateType: string; [key: string]: unknown };
}

// Thin, elegant reading-progress indicator.
const ScrollProgress: React.FC = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001,
  });
  return (
    <motion.div
      style={{ scaleX }}
      className="fixed left-0 top-0 z-50 h-[2px] w-full origin-left bg-brass"
      aria-hidden
      data-pdf-hide
    />
  );
};

// Resolves the correct template for a presentation payload.
export const PresentationPage: React.FC<Props> = ({ data }) => {
  const Template = getTemplate(data.templateType as any);

  if (!Template) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-ivory px-6">
        <p className="max-w-md text-center font-serif text-2xl text-charcoal">
          This presentation type isn't available yet.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-ivory" data-testid="presentation-page">
      <ScrollProgress />
      <Template data={data} />
    </div>
  );
};
